'use client'

import { motion } from 'motion/react'

import { typographyVariants } from '@ui/web/lib'
import cn from '@config/tailwind/cn'

import { authClient } from '~/auth/client'
import { poppins } from '~/font'
import { UserNavigationButton } from '~/lib/user-navigation-button'

interface HeroProps {
  className?: string
}

const fadeUp = (delay: number) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.5, ease: 'easeOut' as const, delay },
})

export function Hero({ className }: HeroProps) {
  const { data: session } = authClient.useSession()

  return (
    <section
      className={cn(
        'text-neutral-black mx-auto flex w-full max-w-7xl flex-col gap-8 px-6 py-9.5',
        poppins.className,
        className,
      )}
    >
      <section className='flex flex-col gap-1 text-center'>
        <motion.h1 className={cn(typographyVariants({ variant: 'display' }))} {...fadeUp(0)}>
          Di mana cerita memicu pembelajaran
        </motion.h1>

        <motion.h2 className={cn(typographyVariants({ variant: 'headline-sm' }), 'text-grey-100')} {...fadeUp(0.12)}>
          Dukung kegiatan membaca, berpikir, dan rasa ingin tahu. Setiap hari, di sekolah dan di rumah.
        </motion.h2>
      </section>

      <motion.section className='flex flex-col gap-4 text-center' {...fadeUp(0.24)}>
        <h6 className={cn(typographyVariants({ variant: 'headline-sm' }))}>Mulai sebagai...</h6>

        <section className='flex w-full flex-wrap items-center justify-center gap-4'>
          <UserNavigationButton userType='teacher' mode='signup' disabled={session !== null} />
          <UserNavigationButton userType='parent' mode='signup' disabled={session !== null} />
          <UserNavigationButton userType='kid' mode='signup' disabled={session !== null} />
        </section>

        {session !== null && <p className={cn(typographyVariants({ variant: 'body-sm' }))}>Kamu sudah masuk</p>}
      </motion.section>
    </section>
  )
}
